<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="p-0">
        <app-side-nav [item]="meetingNav"></app-side-nav>
    </div> -->
  <div class="col-10 p-0 add-employee-section">
    <!-- <app-header></app-header> -->
    <div class="div-style">
      <div class="breadcrumbs-section">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="prev-page pr-1 prev"><a routerLink="/employees/employees-list">Employees</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Add Employees</span>
      </div>
      <label class="meetings padding-left-employees">Add Employees</label>


      <div class="row">
        <div class="col-10">
          <div class="d-flex justify-textbox padding-left-employees mt-4">
            <div class="row" style="width: 100%;">
              <div class="col-6">

                <input type="text" [ngClass]="name?'textbox-onselect':'textbox-style'"
                  [class.error-input]="fieldErrors.includes('name')" class="search-line placeholder-text"
                  [(ngModel)]="fullname" [placeholder]="!name ? 'Full Name' : ''" (click)="enterName('name')"
                  (blur)="enterName('name')" pattern="^[a-zA-Z ]{2,50}$" required (keyup)="inputModelChange('name')">
                <label *ngIf="name" class="form-lable-fullname" for="mobile-emailid">Full Name</label>
                <div class="row" *ngIf="fieldErrors.length > 0">
                  <div class="col-10 field-error"> <span *ngIf="fieldErrors.includes('name')">Please enter valid
                      name</span>
                  </div>
                  <div class="col-10 field-error"> <span *ngIf="fieldErrors.includes('namelen')">Please enter not more
                      than 50 characters
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <input type="email" class="search-line  placeholder-text"
                  [ngClass]="email?'textbox-onselect':'textbox-style'" [(ngModel)]="emailId"
                  [placeholder]="!email ? 'E-Mail ID' : ''" [class.error-input]="fieldErrors.includes('email')"
                  (click)="enterName('email')" (blur)="enterName('email')" (keyup)="inputModelChange('email')"
                  pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$" required>
                <label *ngIf="email" class="form-lable-email" for="mobile-emailid">E-Mail ID</label>
                <div class="row" *ngIf="fieldErrors.length > 0">
                  <div class="col-10 field-error"> <span *ngIf="fieldErrors.includes('email')">Please enter valid
                      email</span>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="d-flex justify-textbox padding-left-employees mt-4">
            <div class="row" style="width: 100%;">
              <div class="col-6">
                <span class="prefix" id="prefix"></span>
                <input type="text" [ngClass]="mobile?'textbox-onselect-mobile':'textbox-style'"
                  class="search-line  placeholder-text" [(ngModel)]="phoneNumber"
                  [placeholder]="!mobile ? 'Mobile Number' : ''" (click)="enterName('mobile')"
                  (keyup)="inputModelChange('phone')" (blur)="enterName('mobile')" maxlength="10" minlength="10"
                  [class.error-input]="fieldErrors.includes('phone')" required>
                <label *ngIf="mobile" class="form-lable-mobile" for="mobile-emailid">Mobile Number</label>
                <div class="row" *ngIf="fieldErrors.length > 0">
                  <div class="col-10 field-error"> <span *ngIf="fieldErrors.includes('phone')">Please enter valid
                      mobile number</span>
                  </div>
                </div>
              </div>
              <div class="col-6">

                <div [ngClass]="dept?'textbox-onselect-dept':'textbox-style'" style="position: relative;">
                  <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'" [ngbPopover]="popContent"
                    triggers="manual" #p="ngbPopover" (click)="openPopover(p);enterName('department')"
                    placement="bottom" popoverClass='dash-popover dashboard-popover'>
                    <input class="pt-3 pb-3 input-width placeholder-text pointer-link" (blur)="enterName('department')"
                      [placeholder]="!dept ? 'Department' : ''" readonly [(ngModel)]="departmentName" required
                      [class.error-input-dept]="fieldErrors.includes('dept')">
                    <img src="/assets/images/Path.png" class="image-pos padding-left-image pr-1" loading="lazy" />
                  </div>
                  <label *ngIf="dept" class="form-lable-dept" for="mobile-emailid">Department</label>

                  <div class="row" *ngIf="fieldErrors.length > 0" style="margin-top: -22px;">
                    <div class="col-10 field-error"> <span *ngIf="fieldErrors.includes('dept')">Please select valid
                        department</span>
                    </div>
                  </div>

                  <div>
                    <ng-template #popContent>
                      <div class="box">
                        <div class="searchBar p-0 m-0">
                          <img src="../../../assets/images/search.png">
                          <input type="text" placeholder='Search' [(ngModel)]="searchDept" />
                        </div>
                        <div class="dashboard-popover ">
                          <div class="d-flex justify-content-between">
                            <div class="pl-3 pt-3 pr-3 pb-3 ">
                              <div class="row pb-2" *ngFor="let dept of deptList.list | filter: searchDept;let index =i"
                                (click)="setDepartment(dept);openPopover(p);inputModelChange('dept')">
                                <div class="popover-content normal-font pl-3 email-width">
                                  {{dept.department}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="padding-left-employees">
        <div class="line "></div>
      </div>
      <div class="d-flex justify-textbox padding-left-employees mt-4 ">
        <div class="activation-width mt-3">
          <span class="pr-4 activation">Activation </span>
          <label class="switch pl-5">
            <input type="checkbox" [checked]="activation" [(ngModel)]="activation" value="tableSelected"
              (change)="toggle($event)">
            <span class="slider round "></span>
            <!-- <label class="checkbox-label">activation</label> -->
          </label>
          <ng-template #activationPopup let-modal class="text-center">
            <div class="modal-height">
              <div class="modal-body">
                <div class="">
                  <div class="text pt-3 pb-3">Are you sure, you want to {{activateText}}?</div>
                  <div class="popup-line"></div>
                </div>
              </div>
              <div class="submit col-12 d-flex justify-content-end col-12-padding">
                <div class="pr-3">
                  <button type="button " class="cancel-button cancel pt-3"
                    (click)="modal.close('Save click'); closeModal()">
                    <span class="cancel">Cancel</span></button>
                </div>
                <button type="button " class="add-button" (click)="toggleActivationSelection($event, member)"><span
                    class="add">{{activateText}}</span></button>
              </div>
            </div>
          </ng-template>
        </div>
        <!-- <div class="activation-width pl-4 mt-3">
          <span class="pr-4 activation">Privilege </span>
          <label class="switch pl-5">
            <input type="checkbox" [(ngModel)]="priviledge" [checked]="priviledge" value="priviledge"
              (change)="togglePriviledgeSelection($event)">
            <span class="slider round "></span>
          </label>
        </div> -->
      </div>
      <div class="padding-left-employees">
        <div class="line "></div>
      </div>
      <div class="d-flex justify-content-between mt-5">
        <div class="padding-left-employees access">
          Access
        </div>
        <div class="justify-content-end padding-right-employees">
          <span class="pr-5 select-all">Select all</span>
          <label class="switch pl-5">
            <input type="checkbox" [checked]="selectAll" [(ngModel)]="selectAll" value="selectAll"
              (change)="toggleSelectAllSelection($event)" [disabled]="!activation">
            <span class="slider round "></span>
          </label>
        </div>
      </div>
      <div *ngIf="entryGate.length>0">
        <span class="padding-left-employees entry-gate">Entry Gate</span>
        <div class="padding-left-employees row d-flex mt-3">
          <ng-container class="" *ngFor="let eg of entryGate;let i=index">
            <div class="pr-4 d-flex">
              <div (click)="changeAccess(eg,'entryGate',i)" [ngClass]="(eg.selected )?'rectangle-select ':'rectangle '">
                <span [ngClass]="(eg.selected )?'text-font':'text-font-deselected'">{{eg.accessPointName}}</span>
              </div>
              <span>
                <img *ngIf="eg.selected " class="image-pos-cross justify-content-end"
                  src="/assets/images/cross-mark.png" (click)="changeAccess(eg,'entryGate',i)" loading="lazy"></span>
            </div>

            <!-- <div class="rectangle">Turnstile 01</div> -->
          </ng-container>
          <!-- <div class="rectangle-select">Turnstile 01</div>
                    <span><img class="image-pos-cross" src="/assets/images/cross-mark.png" ></span>
                    <div class="rectangle">Turnstile 01</div> -->
        </div>

      </div>
      <div class="mt-4" *ngIf="meetingRoomAccess.length>0">
        <span class="padding-left-employees entry-gate ">Meeting Room Access
        </span>
        <div class="padding-left-employees row d-flex mt-3">
          <ng-container class="" *ngFor="let mr of meetingRoomAccess;let i=index">
            <div class="pr-4 d-flex pt-2">
              <div (click)="changeAccess(mr,'meetingRoomAccess',i)"
                [ngClass]="(mr.selected )?'rectangle-select ':'rectangle '">
                <span [ngClass]="(mr.selected )?'text-font':'text-font-deselected'">{{mr.accessPointName}}</span>
              </div>
              <span>
                <img *ngIf="mr.selected " class="image-pos-cross justify-content-end"
                  src="/assets/images/cross-mark.png" (click)="changeAccess(mr,'meetingRoomAccess')"
                  loading="lazy"></span>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="mt-4" *ngIf="deskAccess.length>0">
        <span class="padding-left-employees entry-gate ">Desk Access
        </span>
        <div class="padding-left-employees row d-flex mt-3">
          <ng-container class="" *ngFor="let da of deskAccess;let i=index">
            <div class="pr-4 d-flex pt-2">
              <div (click)="changeAccess(da,'deskAccess',i)"
                [ngClass]="(da.selected )?'rectangle-select ':'rectangle '">
                <span [ngClass]="(da.selected )?'text-font':'text-font-deselected'">{{da.accessPointName}}</span>
              </div>
              <span>
                <img *ngIf="da.selected " class="image-pos-cross justify-content-end"
                  src="/assets/images/cross-mark.png" (click)="changeAccess(da,'deskAccess')" loading="lazy"></span>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="mt-4" *ngIf="privateSuiteAccess.length>0">
        <span class="padding-left-employees entry-gate ">Private Suite Access
        </span>
        <div class="padding-left-employees row d-flex mt-3">
          <ng-container class="" *ngFor="let ps of privateSuiteAccess;let i=index">
            <div class="pr-4 d-flex pt-2">
              <div (click)="changeAccess(ps,'privateSuiteAccess',i)"
                [ngClass]="(ps.selected )?'rectangle-select ':'rectangle '">
                <span [ngClass]="(ps.selected )?'text-font':'text-font-deselected'">{{ps.accessPointName}}</span>
              </div>
              <span>
                <img *ngIf="ps.selected " class="image-pos-cross justify-content-end"
                  src="/assets/images/cross-mark.png" (click)="changeAccess(ps,'privateSuiteAccess')"
                  loading="lazy"></span>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="padding-left-employees">
        <div class="line "></div>
      </div>
      <div class="padding-left-employees mt-4">
        <input type="checkbox" class="styled-checkbox gaps" name="dob" id="dobRadioButton" />
        <label for="dobRadioButton" class="send-invitation-via" (click)="sendInvite($event)">Send invitation via
          Email</label>
      </div>
      <div class="padding-left-employees row d-flex mt-5 mb-5">
        <button class="add-button" [disabled]="disableAdd" (click)="addEmployeeData($event)">
          <span class="add">Add</span>
        </button>
        <div class="pl-3">
          <button class="cancel-button pt-3" (click)="onCancel()">
            <span class="cancel">Cancel</span>
          </button>
        </div>

      </div>
    </div>
    <!-- <app-footer></app-footer> -->
  </div>
</div>
